<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormGarantiaPorArticuloWeb" role="form" method="post" autocomplete="off" onSubmit="return false">

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div class="list-group m-4">
                                <div v-for="(item,index) in ListaTiposDeGarantia" :key="index" class="list-group-item list-group-item-action">
                                    <div class=" form-check-inline form-check form-switch form-sw">
                                        <input type="checkbox" v-model="Seleccionados" class="form-check-input" role="switch" :value="item.TipoGarantia" :id="'idswitchplente'+index" >
                                        <label class="form-check-label" for="flexSwitchCheckDefault">{{ item.Texto }}</label>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import Combos from '@/helpers/StaticComboBox.js';

export default {
    name: 'FormGarantiaPorArticuloWeb',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objGarantiaPorArticuloWeb: {
				IdGarantiaArticulo: 0,
				IdArticuloWeb: 0,
				TipoGarantia: '',
				IdUserCreate: 0,	
            },
            Seleccionados: [],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            ListaTiposDeGarantia: Combos.TiposDeGarantia,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
            let formData = new FormData();
			formData.set('IdGarantiaArticulo', this.objGarantiaPorArticuloWeb.IdGarantiaArticulo);
			formData.set('IdUserCreate', this.objGarantiaPorArticuloWeb.IdUserCreate);
			formData.set('IdArticuloWeb', this.objGarantiaPorArticuloWeb.IdArticuloWeb);
			formData.set('ListGarantias', JSON.stringify(this.Seleccionados));
			
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
			
			await this.$http.post('garantiasPorArticulosWeb', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get("garantiasPorArticulosWeb",{
                params:{
                    IdArticuloWeb: this.objGarantiaPorArticuloWeb.IdArticuloWeb,
                    Simple: 1,
                }
            }).then((res) => {

                let response = res.data.data;
                let ArrayPush = [];
                response.map(function(element)
                {
                    ArrayPush.push(element.TipoGarantia)

                });

                this.Seleccionados = ArrayPush;
                
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objGarantiaPorArticuloWeb = {
				IdGarantiaArticulo: 0,
				IdArticuloWeb: 0,
				TipoGarantia: '',
				IdUserCreate: 0,
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(item)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });

            this.Limpiar();
            this.ConfigLoad.ShowLoader = false;
            
            // this.Seleccionados = ["Graduacion", "Antiflex", "Crizal", "Adaptacion", "Otros"]
                
            if (item.IdArticuloWeb > 0) 
            {
                this.objGarantiaPorArticuloWeb.IdArticuloWeb = item.IdArticuloWeb;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
